<main>
    <h1 class="dialog-title dialog-title--bigger" >{{"DeleteUser" | translate}}</h1>

    <mat-dialog-content>
        <p>
          {{"ConfirmationDeleteClientFirstPart" | translate}} <strong><br>{{client.FirstName}} {{client.LastName}} </strong> {{"ConfirmationDeleteClientSecondtPart" | translate}}
        </p>
    </mat-dialog-content>

    <div *ngIf="!isLoadingSave">
      <section class="dialog-loading-container">
        <div class="pulsing">
          <mat-spinner [diameter]="50"></mat-spinner>
        </div>
        <p class="dialog__loading-text">{{"Loading" | translate}}</p>
      </section>
    </div>
  
    <mat-dialog-actions align="center" 
      [ngClass]="{'contenido-deshabilitado': !isLoadingSave}">
        <button class="dialog__button" (click)="onCancel()">
          {{"Cancel" | translate}}
        </button>
        <button class="dialog__button dialog__button--fill" (click)="onSave()">
          {{"Accept" | translate}}
        </button>
    </mat-dialog-actions>
    
  </main>
  
